export default __webpack_public_path__ + "static/Room-With-A-View-Sydney-Opera-House-592dd6a6b4287b4836cbe3027c70c94f.jpg";